import { render } from "./uk9.vue?vue&type=template&id=5879e515"
import script from "./uk9.vue?vue&type=script&lang=js"
export * from "./uk9.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__